import { Checkbox } from '@/components/atoms';
import { SurveyOverviewBuilderQuestion } from '@/pages/Surveys/SurveysOverviewBuilder/types';

import { Step } from '../../Stepper/Stepper';
import { SurveyQuestionSetStepperData, SurveyQuestionStepperData } from '../SurveyQuestionStepper';

export const SurveyQuestionChoiceStep = (
  stepperData: SurveyQuestionStepperData,
  setStepperData: SurveyQuestionSetStepperData,
  question: SurveyOverviewBuilderQuestion,
  index: number,
  total: number
) => {
  const handleChange = (value: string, checked: boolean) => {
    setStepperData(prev => {
      const newValue = checked
        ? [...prev.selected, value]
        : prev.selected.filter(item => item !== value);

      return { ...prev, selected: newValue };
    });
  };

  const step: Step = {
    value: index,
    content: (
      <div className="w-full">
        <div className="flex items-center gap-1.5 mb-5 text-body-14-medium text-custom-warm-grey-400">
          <p>
            Question {index + 1} of {total}
          </p>
          {!question.required && (
            <div className="flex items-center gap-2">
              <span className="size-1 bg-custom-warm-grey-400 inline-block rounded-full" />
              <p>Optional</p>
            </div>
          )}
        </div>
        <h4 className="text-body-24-semibold text-custom-warm-grey-700 mb-5">
          {question.question}
        </h4>
        <div className="flex flex-col gap-3">
          {question.options.map(option => (
            <label
              key={option}
              className="flex items-center gap-3 px-3 py-2 border border-custom-warm-grey-200 rounded-[12px] cursor-pointer select-none"
              id={option}
            >
              <Checkbox
                id={option}
                checked={stepperData.selected.includes(option)}
                onCheckedChange={checked => handleChange(option, Boolean(checked))}
              />
              <p className="text-body-16-regular text-custom-warm-grey-700">{option}</p>
            </label>
          ))}
        </div>
      </div>
    ),
  };

  return step;
};
